import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Container, Dimmer, Table, Card,
  Button, Avatar, Page
} from "tabler-react";
import SearchInput from '../../components/searchInput';

const RecordsTable = ({
  headers,
  records,
  openMainModal,
  loading,
  reload,
  searchQuery,
  onSearch
}) => {
  const history = useHistory()

  return (
    <Container>
      <Page.Header>
        <Page.Title>Countries</Page.Title>
      </Page.Header>
      <Card>
        <Dimmer active={loading} loader={loading}>
          <Card.Header>
            <Card.Options>
              <SearchInput value={searchQuery} onSubmit={onSearch} />
              <Button
                className="ml-2"
                icon="plus"
                color="primary"
                size="md"
                onClick={() => openMainModal('country-create', null, reload)}
              >
                Create Country
              </Button>
              <Button
                outline
                className="ml-2"
                icon="plus"
                color="secondary"
                size="md"
                onClick={() => openMainModal('city-create')}
              >
                Create City
              </Button>
            </Card.Options>
          </Card.Header>

          {!loading && records.length < 1 ? (
            <div className="alert alert-primary m-0">
              No Countries to show!
            </div>
          ) : (
            <div className="table-responsive-wrapper">
              <Table hasOutline striped>
                <Table.Header>
                  {headers.map((head, i) => (
                    <Table.ColHeader key={`tableHeader-${i}`}>
                      {head}
                    </Table.ColHeader>
                  ))}
                  <Table.ColHeader>Actions</Table.ColHeader>
                </Table.Header>

                <Table.Body>
                  {records.map((r, i) => (
                    <Table.Row key={i}>
                      {Object.keys(r).map((k, idx) => {
                        if (k === 'flag') {
                          return (
                            <Table.Col key={`${i}-${k}`}>
                              <Avatar size="sm" imageURL={r['flag']} />
                            </Table.Col>
                          );
                        } else if (k === 'id') {
                          return null;
                        } else {
                          return (<Table.Col key={`${i}-${k}`}>{r[k]}</Table.Col>);
                        }
                      })}
                      
                      <Table.Col>
                        <div className="actions-wrap">
                          <Button
                            outline
                            color="secondary"
                            size="sm"
                            onClick={() => openMainModal('country-edit', r['id'], reload)}
                          >
                            Edit
                          </Button>

                          <Button
                            outline
                            color="danger"
                            className="ml-2 mr-2"
                            size="sm"
                            onClick={() => openMainModal('countries--delete', r['id'], reload)}
                          >
                            Delete
                          </Button>

                          <Button
                            outline
                            color="secondary"
                            size="sm"
                            onClick={() => history.push(`/countries/cities/${r['id']}`)}
                          >
                            View City
                          </Button>
                        </div>
                      </Table.Col>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          )}
        </Dimmer>
      </Card>
    </Container>
  );
}

export default RecordsTable;